export default [
  {
    path: '/userInfo',
    name: 'userInfo',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: true,
      title: '个人中心',
      pageId: 'userInfo',
      pageName: '个人中心',
      parentId: null,
      parentName: null,
      pageLayer: 1,
    },
    component: resolve => require(['@/views/center/userInfo'], resolve),
  },
  {
    path: '/newsInfo',
    name: 'newsInfo',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: true,
      title: '消息中心',
      pageId: 'newsInfo',
      pageName: '消息中心',
      parentId: null,
      parentName: null,
      pageLayer: 1,
    },
    component: resolve => require(['@/views/center/newsInfo'], resolve),
  },
  {
    path: '/myTask',
    name: 'myTask',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: true,
      title: '我的任务',
      pageId: 'myTask',
      pageName: '我的任务',
      parentId: null,
      parentName: null,
      pageLayer: 1,
    },
    component: resolve => require(['@/views/myTask/myTask'], resolve),
  },
  {
    path: '/myReward',
    name: 'myReward',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: true,
      title: '我的报酬',
      pageId: 'myReward',
      pageName: '我的报酬',
      parentId: null,
      parentName: null,
      pageLayer: 1,
    },
    component: resolve => require(['@/views/myReward/myReward'], resolve),
  },
  {
    path: '/pTimeAudit',
    name: 'pTimeAudit',
    meta: {
      title: '兼职审核',
      pageId: 'pTimeAudit',
      pageName: '兼职审核',
      parentId: null,
      parentName: null,
      pageLayer: 1,
    },
    component: resolve => require(['@/views/pTimeAudit/layout'], resolve),
    children: [
      {
        path: '/pTimeAudit/reportHouse',
        name: 'pTimeAudit_reportHouse',
        meta: {
          checkLogin: true,
          keepAlive: false,
          isFooter: true,
          bgAudit: true,
          title: '报告库',
          pageId: 'reportHouse',
          pageName: '报告库',
          parentId: 'pTimeAudit',
          parentName: '兼职审核',
          pageLayer: 2,
        },
        component: resolve => require(['@/views/pTimeAudit/reportHouse'], resolve),
      },
      {
        path: '/pTimeAudit/reportAudit',
        name: 'pTimeAudit_reportAudit',
        meta: {
          checkLogin: true,
          keepAlive: false,
          isFooter: true,
          bgAudit: true,
          title: '我的审核',
          pageId: 'reportAudit',
          pageName: '我的审核',
          parentId: 'pTimeAudit',
          parentName: '兼职审核',
          pageLayer: 2,
        },
        component: resolve => require(['@/views/pTimeAudit/reportAudit'], resolve),
      },
      {
        path: '/pTimeAudit/reportReward',
        name: 'pTimeAudit_reportReward',
        meta: {
          checkLogin: true,
          keepAlive: false,
          isFooter: true,
          bgAudit: true,
          title: '我的收入',
          pageId: 'reportReward',
          pageName: '我的收入',
          parentId: 'pTimeAudit',
          parentName: '兼职审核',
          pageLayer: 2,
        },
        component: resolve => require(['@/views/pTimeAudit/reportReward'], resolve),
      },
    ],
  },
  {
    path: '/pTimeAudit/signOnline',
    name: 'pTimeAudit_signOnline',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: true,
      bgAudit: true,
      title: '线上签约',
      pageId: 'signOnline',
      pageName: '线上签约',
      parentId: 'pTimeAudit',
      parentName: '兼职审核',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/pTimeAudit/signOnline'], resolve),
  },
];
